 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"employee-account-settings":"employee-account-settings","employee-change-password~employee-message":"employee-change-password~employee-message","employee-change-password":"employee-change-password","employee-message":"employee-message","employee-dashboard~employee-rtl":"employee-dashboard~employee-rtl","employee-dashboard":"employee-dashboard","employee-device-management":"employee-device-management","employee-document-editor":"employee-document-editor","employee-enrollment":"employee-enrollment","employee-forgot-password":"employee-forgot-password","employee-invoice-sheets":"employee-invoice-sheets","employee-payroll":"employee-payroll","employee-pdf-editor":"employee-pdf-editor","employee-profile~employee-rtl~employee-virtual-reality":"employee-profile~employee-rtl~employee-virtual-reality","employee-profile~employee-rtl":"employee-profile~employee-rtl","employee-rtl":"employee-rtl","employee-profile":"employee-profile","employee-virtual-reality":"employee-virtual-reality","employee-reset-password":"employee-reset-password","employee-sign-in":"employee-sign-in","employee-sign-up":"employee-sign-up","employee-switch-client":"employee-switch-client","employee-time-sheet":"employee-time-sheet","worker-guide":"worker-guide"}[chunkId]||chunkId) + "." + {"employee-account-settings":"017699da","employee-change-password~employee-message":"c18f3922","employee-change-password":"a8b6e36b","employee-message":"cf7d750f","employee-dashboard~employee-rtl":"9b32d097","employee-dashboard":"21af03e5","employee-device-management":"fd717ccf","employee-document-editor":"332d53ae","employee-enrollment":"15fd8e02","employee-forgot-password":"3e26e34e","employee-invoice-sheets":"ce19534a","employee-payroll":"b7f29fa6","employee-pdf-editor":"743ced04","employee-profile~employee-rtl~employee-virtual-reality":"699c7458","employee-profile~employee-rtl":"82ee99e9","employee-rtl":"c24ac1f5","employee-profile":"863778e5","employee-virtual-reality":"8951f952","employee-reset-password":"04cb86a5","employee-sign-in":"8d1fa852","employee-sign-up":"88d76a76","employee-switch-client":"0ecab69e","employee-time-sheet":"e49c0c7c","worker-guide":"9825a890"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"employee-account-settings":1,"employee-dashboard~employee-rtl":1,"employee-device-management":1,"employee-document-editor":1,"employee-enrollment":1,"employee-payroll":1,"employee-pdf-editor":1,"employee-sign-in":1,"employee-switch-client":1,"employee-time-sheet":1,"worker-guide":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"employee-account-settings":"employee-account-settings","employee-change-password~employee-message":"employee-change-password~employee-message","employee-change-password":"employee-change-password","employee-message":"employee-message","employee-dashboard~employee-rtl":"employee-dashboard~employee-rtl","employee-dashboard":"employee-dashboard","employee-device-management":"employee-device-management","employee-document-editor":"employee-document-editor","employee-enrollment":"employee-enrollment","employee-forgot-password":"employee-forgot-password","employee-invoice-sheets":"employee-invoice-sheets","employee-payroll":"employee-payroll","employee-pdf-editor":"employee-pdf-editor","employee-profile~employee-rtl~employee-virtual-reality":"employee-profile~employee-rtl~employee-virtual-reality","employee-profile~employee-rtl":"employee-profile~employee-rtl","employee-rtl":"employee-rtl","employee-profile":"employee-profile","employee-virtual-reality":"employee-virtual-reality","employee-reset-password":"employee-reset-password","employee-sign-in":"employee-sign-in","employee-sign-up":"employee-sign-up","employee-switch-client":"employee-switch-client","employee-time-sheet":"employee-time-sheet","worker-guide":"worker-guide"}[chunkId]||chunkId) + "." + {"employee-account-settings":"77c80afc","employee-change-password~employee-message":"31d6cfe0","employee-change-password":"31d6cfe0","employee-message":"31d6cfe0","employee-dashboard~employee-rtl":"25be9a07","employee-dashboard":"31d6cfe0","employee-device-management":"480e7d66","employee-document-editor":"fad714db","employee-enrollment":"4af693e8","employee-forgot-password":"31d6cfe0","employee-invoice-sheets":"31d6cfe0","employee-payroll":"eda4cf73","employee-pdf-editor":"797cfca8","employee-profile~employee-rtl~employee-virtual-reality":"31d6cfe0","employee-profile~employee-rtl":"31d6cfe0","employee-rtl":"31d6cfe0","employee-profile":"31d6cfe0","employee-virtual-reality":"31d6cfe0","employee-reset-password":"31d6cfe0","employee-sign-in":"e7a78878","employee-sign-up":"31d6cfe0","employee-switch-client":"b520d1ea","employee-time-sheet":"12f0c020","worker-guide":"ec042849"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
